// extracted by mini-css-extract-plugin
module.exports = {"controllers":"VehiclesControllers_controllers__1XGlU","vehicles_count":"VehiclesControllers_vehicles_count__1ob6n"};